<template>
    <m-slide-up :show="show" @close="() => (emit('close'), emit('update:show', false))" >
        <div class="px-7">
            <h1 class="font-bold text-base">Assigned Users</h1>

            <!-- <m-search-user v-if="editMode" class="mb-4" :users="modifiedUsers" @selected="(user) => emit('addUser', user)"/> -->

            <m-search-pop-list
				v-if="editMode"
				placeholder="Add user or ward"
				class="mb-3 "
				:searchList="modifiedUsers"
				@input="(text) => searchText = text"
				@close="() => searchText = ''"
				@change="(item) => (emit('addUser', item), searchText = '')"
				>
			</m-search-pop-list>

            <m-assigned-user-list 
                :editMode="editMode"
                :users="assignedUsers" 
                @removeUser="(user) => emit('removeUser', user)" />
        </div>
    </m-slide-up>
</template>


<script setup>
/* =========== UTILS ======== */
import UserUtils from '@/helpers/userUtils'
import store from '@/store'
import {defineProps, computed, defineEmits, ref} from 'vue'

/* =========== PROPS ========= */
const props = defineProps({
    editMode     : {type : Boolean, default : false},
    assignedUsers: {type : Array, default : () => []},
    users        : {type : Array, default : () => []},
    show         : {type : Boolean, default : () => false},
    wards : {type : Array, default : () => []},
})

/* ========== EMITS ======= */
const emit = defineEmits(['addUser', 'removeUser', 'update:show', 'close'])

/* =========== STATES ======== */
const searchText = ref(null)

/* =========== COMPUTED ======== */

/**
 * Logged in user
 */
const currentUser = computed(() => store.state.user || null)

/**
 * Modified users
 * removed added users from the list
 */
 const modifiedUsers = computed(() => {
    if(!searchText.value) return []

    const isWard = UserUtils.isAssignedToStakeOrWard(currentUser?.value?.user_assign_wards || []) == 'ward' ? true : false;
	let list = props.users.filter(user => !props.assignedUsers?.find(u => u.ID == user.ID))
    let wards = isWard ? currentUser?.value?.user_assign_wards : props.wards?.map(w => w?.site_domain);

    // Remove ward that has no user assigned to them
    // Logged in user has the role of admin. Let user has access to all user list
    wards = wards?.filter(w => {
        const wardUsers = currentUser?.value?.user_info?.roles?.includes?.('administrator') ? props.users :  props.users.filter(user => user.assign_ward && user.assign_ward.includes(w));
        return wardUsers.length > 0;
    });
    console.log('wards', wards)
    
    wards = wards?.map(w => 
        {
            return {
                label : w,
                value : w,
                type : 'ward'
            }
        }
    ) || []
    /**
     * Filter list assign_ward and return users that has same user_assign_wards of the currentUser
     */
    if (isWard) {
        /**
         * Check if logged in user has the role of admin. Let user get access to all user list
         */
        list = currentUser?.value?.user_info?.roles?.includes?.('administrator') ? list : list.filter(user => {
            if (!user.assign_ward || !Array.isArray(user.assign_ward)) return false;
            
            return user.assign_ward.some(ward => 
                currentUser.value?.user_assign_wards?.includes?.(ward)
            );
        });
    }

    list = list.map(l => {
        return {
            label : `${UserUtils.getFullName(l)} - (${l?.assign_position})`,
            value : l?.ID,
            type : 'user'
        }
    })

    

    list = [...list, ...wards] ;

    return list.filter(l => l.label?.toLowerCase().includes(searchText?.value?.toLowerCase()))
})


</script>